import axios from "axios";
import interceptors from "@/shared/api/interceptors";
window.domain = window.__CONFIG__.VUE_APP_BASE_DOMAIN;

const apiClient5 = axios.create({
  baseURL: window.domain + "/logs",
  withCredentials: true,
});

interceptors(apiClient5);

export default apiClient5;
